class SCModal extends HTMLElement {
  constructor() {
    super();

    this.cancelBtns = this.querySelectorAll(".js-btn-cancel");
    this.keepBtns = this.querySelectorAll(".js-btn-keep");
    this.videoEl = this.querySelector("video");
    this.upgradeBtn = this.querySelector(".js-upgrade-btn");
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    document.addEventListener("click", this.handleCancelBtnClick.bind(this), true);

    this.addEventListener("click", (e) => {
      if (!e.target.closest(".js-modal-content")) {
        this.close();
      }
    });

    this.cancelBtns.forEach((btn) => btn.addEventListener("click", this.cancel.bind(this)));
    this.keepBtns.forEach((btn) => btn.addEventListener("click", this.close.bind(this)));
  }

  handleCancelBtnClick(e) {
    if (e.__fromSCModal) return;

    const container = e.target.closest("[data-recharge-subscription-cancel='true']");
    const btn = container?.querySelector("[role='button']");
    if (!btn) return;
    this.initialBtn = btn;

    e.preventDefault();
    e.stopPropagation();

    this.open();
  }

  open() {
    this.ariaExpanded = true;
    this.videoEl.currentTime = 0;
    this.videoEl.play();
  }

  close() {
    this.ariaExpanded = false;
    this.videoEl.pause();
  }

  cancel() {
    this.close();
    if (!this.initialBtn) return;
    const newClick = new MouseEvent("click", { bubbles: true });
    newClick.__fromSCModal = true;
    this.initialBtn.dispatchEvent(newClick);
  }
}

if(!customElements.get("sc-modal")) {
  customElements.define("sc-modal", SCModal);
}
